import { Helmet } from 'react-helmet-async';

interface DocumentTitleProps {
  title: string;
}

export function DocumentTitle({ title }: DocumentTitleProps) {
  return (
    <Helmet>
      <title>{title} | Customer.io</title>
    </Helmet>
  );
}
